import * as React from 'react';

export default class Upascendings extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
        <path stroke="#43ADF1" strokeLinecap="round" strokeLinejoin="round" d="M6.728 12.061V1.5L3.5 4.73"/>
        <path stroke="#020303" strokeLinecap="round" strokeLinejoin="round" d="M9.5 3.5v10.562l3.228-3.228"/>
      </svg>
    )
  }
}
